import React, { useState, useEffect } from 'react';
import { CATEGORIES_WITH_SUBCATEGORIES } from '@/constants/businessAds.constants';
import { Select } from '@sm-dashboard/ui-components';
import { Box } from '@mui/material';

interface CategorySelectorProps {
  selectedCategory: string;
  setSelectedCategory: (category: string) => void;
  selectedSubcategory: string[];
  setSelectedSubcategory: (subcategory: string[]) => void;
}

const CategorySelector: React.FC<CategorySelectorProps> = ({
  selectedCategory,
  setSelectedCategory,
  selectedSubcategory,
  setSelectedSubcategory
}) => {
  const [availableSubcategories, setAvailableSubcategories] = useState<string[]>([]);
  const isOtherCategory = selectedCategory === 'אחר';

  useEffect(() => {
    const categoryData = CATEGORIES_WITH_SUBCATEGORIES.find(cat => cat.name === selectedCategory);
    const newAvailableSubcategories = categoryData ? categoryData.subcategories : [];
    setAvailableSubcategories(newAvailableSubcategories);

    // Reset subcategory if category changed or if "אחר" is selected
    if (isOtherCategory) {
      setSelectedSubcategory([]);
    } else {
      // If subcategories changed, reset invalid selections
      const validSubcategories = selectedSubcategory.filter(sub => newAvailableSubcategories.includes(sub));
      if (validSubcategories.length !== selectedSubcategory.length) {
        setSelectedSubcategory(validSubcategories);
      }
    }
  }, [selectedCategory]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Select
        appearance='plain'
        label="קטגוריה"
        value={selectedCategory}
        onChange={setSelectedCategory}
        options={CATEGORIES_WITH_SUBCATEGORIES.map(category => ({ value: category.name, label: category.name }))}
      />

      {!isOtherCategory && (
        <Select
          appearance="plain"
          label="תת קטגוריה (ניתן לבחור מספר)"
          multiple
          value={selectedSubcategory}
          onChange={setSelectedSubcategory}
          disabled={!selectedCategory || availableSubcategories.length === 0}
          placeholder="בחר תת קטגוריות"
          options={availableSubcategories.map(subcategory => ({ value: subcategory, label: subcategory }))}
        />
      )}
    </Box>
  );
};

export default CategorySelector;
